import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import StudioBrand from './StudioBrand';
import GenerationShell from './GenerationShell';
import '../styles/studio.css';

export default function LegalPageLayout({ title, children }) {
  const { user } = useAuth();
  const content = <article className="studio-legal-content"><h1>{title}</h1><div className="studio-legal-body">{children}</div></article>;
  if (user) return <GenerationShell>{content}</GenerationShell>;
  return <div className="adfini-studio studio-legal-page"><header className="studio-legal-header"><StudioBrand /><Link to="/" className="studio-back-link"><ArrowLeft size={16} aria-hidden />Back to home</Link></header><main>{content}</main></div>;
}
